import { Toaster } from "react-hot-toast";
import { useAtomValue } from "jotai";
import { BOTTOM_RIGHT_TOASTER_ID, NOTIFICATIONS_PANEL_WIDTH } from "../alerts/constants";
import { useNotificationCentreEnabled } from "../alerts/feature-flag";
import { sidebarStateAtom } from "../alerts/sidebarState";
import { bottomBarHeight } from "../globals";
import { BottomRightToastLimit } from "./BottomRightToastLimit";
import { BOTTOM_RIGHT_TOAST_GAP } from "./bottomRightToastStack";

const toastStyle = {
  background: "var(--color-card)",
  color: "var(--color-foreground)",
  textAlign: "center" as const,
};

export function ToasterContainer() {
  const notificationCentreEnabled = useNotificationCentreEnabled();
  const sidebarState = useAtomValue(sidebarStateAtom);
  const notificationsPanelOffset = notificationCentreEnabled && sidebarState.isOpen ? NOTIFICATIONS_PANEL_WIDTH : 0;

  return (
    <>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerStyle={{
          bottom: bottomBarHeight + 16,
        }}
        toastOptions={{ style: toastStyle }}
      />
      <Toaster
        toasterId={BOTTOM_RIGHT_TOASTER_ID}
        position="bottom-right"
        // Newest toast stays on the corner; older ones are offset upward.
        reverseOrder={false}
        gutter={BOTTOM_RIGHT_TOAST_GAP}
        containerStyle={{
          bottom: bottomBarHeight + 16,
          right: 16 + notificationsPanelOffset,
        }}
        toastOptions={{
          style: {
            ...toastStyle,
            padding: 0,
            background: "transparent",
            boxShadow: "none",
            maxWidth: "none",
          },
        }}
      />
      <BottomRightToastLimit />
    </>
  );
}
